export default {
    collapseButton: {
        collapse: "Replier",
        expand: "Déplier"
    }
};
